import { cn } from 'components/shadcn/lib';
export const PageLayout = ({ children, className }) => {
  return (
    <div
      className={cn(
        'flex min-h-screen flex-col items-center justify-center bg-muted p-6 md:p-10',
        className,
      )}
    >
      {children}
    </div>
  );
};
